/* Analyte List */
export const GET_ORGANISM_LIST = "GET_ORGANISM_LIST";
export const GET_ORGANISM_LIST_SUCCESS = "GET_ORGANISM_LIST_SUCCESS";
export const GET_ORGANISM_LIST_FAIL = "GET_ORGANISM_LIST_FAIL";

///////////////////////////////////////
export const ADD_ORGANISM_LIST = "ADD_ORGANISM_LIST";
export const ADD_ORGANISM_LIST_SUCCESS = "ADD_ORGANISM_LIST_SUCCESS";
export const ADD_ORGANISM_LIST_FAIL = "ADD_ORGANISM_LIST_FAIL";

export const UPDATE_ORGANISM_LIST = "UPDATE_ORGANISM_LIST";
export const UPDATE_ORGANISM_LIST_SUCCESS = "UPDATE_ORGANISM_LIST_SUCCESS";
export const UPDATE_ORGANISM_LIST_FAIL = "UPDATE_ORGANISM_LIST_FAIL";

export const DELETE_ORGANISM_LIST = "DELETE_ORGANISM_LIST";
export const DELETE_ORGANISM_LIST_SUCCESS = "DELETE_ORGANISM_LIST_SUCCESS";
export const DELETE_ORGANISM_LIST_FAIL = "DELETE_ORGANISM_LIST_FAIL";


///////////////////////////////////////
export const GET_ANTIBIOTIC_LIST = "GET_ANTIBIOTIC_LIST";
export const GET_ANTIBIOTIC_LIST_SUCCESS = "GET_ANTIBIOTIC_LIST_SUCCESS";
export const GET_ANTIBIOTIC_LIST_FAIL = "GET_ANTIBIOTIC_LIST_FAIL";

export const ADD_ANTIBIOTIC_LIST = "ADD_ANTIBIOTIC_LIST";
export const ADD_ANTIBIOTIC_LIST_SUCCESS = "ADD_ANTIBIOTIC_LIST_SUCCESS";
export const ADD_ANTIBIOTIC_LIST_FAIL = "ADD_ANTIBIOTIC_LIST_FAIL";

export const UPDATE_ANTIBIOTIC_LIST = "UPDATE_ANTIBIOTIC_LIST";
export const UPDATE_ANTIBIOTIC_LIST_SUCCESS = "UPDATE_ANTIBIOTIC_LIST_SUCCESS";
export const UPDATE_ANTIBIOTIC_LIST_FAIL = "UPDATE_ANTIBIOTIC_LIST_FAIL";

export const DELETE_ANTIBIOTIC_LIST = "DELETE_ANTIBIOTIC_LIST";
export const DELETE_ANTIBIOTIC_LIST_SUCCESS = "DELETE_ANTIBIOTIC_LIST_SUCCESS";
export const DELETE_ANTIBIOTIC_LIST_FAIL = "DELETE_ANTIBIOTIC_LIST_FAIL";